var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGreenPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1825 12.2194C1.09001 12.2193 0.998558 12.1999 0.913971 12.1625C0.829383 12.125 0.753507 12.0704 0.691166 12.0021C0.627699 11.9344 0.579269 11.854 0.549052 11.7662C0.518835 11.6784 0.507515 11.5852 0.515833 11.4928L0.679166 9.69677L8.2245 2.1541L10.5825 4.51143L3.03917 12.0534L1.24317 12.2168C1.223 12.2186 1.20275 12.2195 1.1825 12.2194ZM11.0532 4.0401L8.69583 1.68277L10.1098 0.268767C10.1717 0.206782 10.2453 0.15761 10.3262 0.12406C10.4071 0.0905106 10.4939 0.0732422 10.5815 0.0732422C10.6691 0.0732422 10.7559 0.0905106 10.8368 0.12406C10.9177 0.15761 10.9913 0.206782 11.0532 0.268767L12.4672 1.68277C12.5292 1.74468 12.5783 1.81821 12.6119 1.89914C12.6454 1.98007 12.6627 2.06682 12.6627 2.15443C12.6627 2.24204 12.6454 2.32879 12.6119 2.40973C12.5783 2.49066 12.5292 2.56418 12.4672 2.6261L11.0538 4.03943L11.0532 4.0401Z",
    fill: "#06685E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGreenPen);
export default __webpack_public_path__ + "static/media/ic_green_pen.0e33ba0bc3fcf90419077a391f05cad5.svg";
export { ForwardRef as ReactComponent };